<body>
    <div class="content flex-row">
        <div #div1 class="flex-25 flex-lg-25 flex-md-30 flex-sm-40 flex-xs-40 flex-xsm-50 div"
            [@slideInOut]="{value: animationState, params:{inWidth: priorityWidth}}">
            <div *ngIf="showPriority" class="flex-column" style="height: 100%;">
                <div class="search-bar-pg">
                    <mat-icon class="search-icon" matPrefix>search</mat-icon>
                    <input class="priority-search-text" placeholder="Search..."
                        (ngModelChange)="onPrioritySearch($event)" [(ngModel)]="selectedPriority">
                </div>
                <!-- 
                <div class="scrollable-container"> -->
                <!-- <div class="scrollable"> -->
                <div class="div3 scrollable flex-column">
                    <div class="priority-group-container" *ngFor="let priorityGroup of filteredPriorities"
                        [ngClass]="{'active-priority-item': priorityGroup.id === activeId, 'priority-item': priorityGroup.id !== activeId }"
                        (click)="getRankings(priorityGroup, false)">
                        <div class="priority-heading-container">
                            <label class="priority-heading">{{ activeSeason.description }}
                                {{ 'PRIORITY-GROUPS.SEASON' | translate }}</label>
                            <label class="priority-sub-heading">{{ priorityGroup.cultivarName }}</label>
                        </div>
                        <div class="row-flex">
                            <div class="priority-sub-heading-1 col-flex-item vertical-divider">
                                <label class="label-hover label-small"><strong>{{
                                        formatTimeStamp(priorityGroup.lastCalculation) }}</strong></label>
                                <label class="label-hover label-last-calculation">{{ 'PRIORITY-GROUPS.LAST-CALCULATION' | translate }}</label>
                            </div>
                            <div class="priority-sub-heading-1 col-flex-item">
                                <label class="label-hover label-small"><strong>{{
                                        formatTimeStamp(priorityGroup.startDate )}}
                                        -
                                        {{ formatTimeStamp(priorityGroup.endDate )}}</strong></label>
                                <label class="label-hover label-last-calculation">{{ 'PRIORITY-GROUPS.PLANT-DATE' | translate }}</label>
                            </div>
                        </div>
                    </div>
                </div>

                <button mat-icon-button (click)="toggleGroups(div1.offsetWidth)" class="expand-toggle-button">
                <div class="expand-toggle flex-row justify-center align-center">
<!--                        <label class="expand-label">{{ 'PRIORITY-GROUPS.CLOSE-GROUP' | translate }} </label>-->
                    <h2 class="close-farm-select">{{ 'PRIORITY-GROUPS.CLOSE-GROUP' | translate }}</h2>
                        <mat-icon class="expand-icon">keyboard_arrow_left</mat-icon>
                </div>
                </button>
            </div>
            <div *ngIf="!showPriority" class="expand-toggle-big-button" (click)="toggleGroups(div1.offsetWidth)">
                <button mat-icon-button class="expand-priorities">
                    <mat-icon>keyboard_arrow_right</mat-icon>
                </button>
            </div>
        </div>
        <div #div2 class="flex-100 graph" [@slideInOut1]="{value: animationState, params:{inWidth: priorityWidth}}">
            <div class="flex-row" style="height: 48px; width: 100%;">
                <div class="toggle-main-container flex-row justify-center align-center">
                    <button mat-icon-button (click)="openBottomSheet()" class="priority-toggle-container flex-column justify-center align-center">
                        <mat-icon class="expand-rankings">expand_less</mat-icon>
                        <label class="expand-rankings-label">{{ 'PRIORITY-GROUPS.RANKINGS' | translate }}</label>
                    </button>
                </div>

            <div *ngIf="showImage" class="priority-image">
<!--                <img class="priority-image" src="../../assets/img/priority_groups.png" alt="Priority Groups"/>-->
            </div>

            </div>
            <div *ngIf="!showImage" class="headings-main flex-column justify-center align-center">
               <div>  <label class="priority-graph-heading">{{ seasonTitle }}
                   {{ 'PRIORITY-GROUPS.SEASON' | translate }} | {{ cropTitle }}</label> </div>
                <div class="sub-header-spacer"> <label class="priority-graph-sub-heading">{{ 'PRIORITY-GROUPS.GRAPH' | translate }}</label></div>
            </div>
<!--            style=" min-height: 400px; max-height: 650px; height: 650px; "-->
            <div class="graph-container-main" >
            <div *ngIf="!showImage" class="graph-container">
                <div class="priority-groups__chart flex-row justify-center align-center">
                <div id="chart" class="graph">
                    <apx-chart  [series]="ndviLineChart" [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis"
                        [stroke]="chartOptions.stroke" [tooltip]="chartOptions.tooltip"
                        [dataLabels]="chartOptions.dataLabels" [legend]="chartOptions.legend"
                        [yaxis]="chartOptions.yaxis"></apx-chart>
                </div>
                </div>
            </div>
            <!-- <ngx-charts-line-chart [scheme]="colorScheme" [legend]="lineLegend" [showXAxisLabel]="lineShowXAxisLabel"
            [showYAxisLabel]="lineShowYAxisLabel" [xAxis]="lineXAxis" [yAxis]="lineYAxis" [xAxisLabel]="lineXAxisLabel"
            [yAxisLabel]="lineYAxisLabel" [results]="ndviChartData" [legendPosition]="lineLegendPosition"
            [rotateXAxisTicks]="lineRotateXAxisTicks" [maxXAxisTickLength]="lineXAxisTick" trimXAxisTicks="true"
            (select)="onSelect($event)">
        </ngx-charts-line-chart> -->
        </div>

        </div>

        </div>
</body>
